// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
function IconFacebook(Props) {
  return React.createElement("svg", {
    height: "23",
    width: "27",
    fill: "none",
    viewBox: "0 0 27 23",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    clipRule: "evenodd",
    d: "M11.5 10.129C11.5 8.20749 13.0579 6.64775 14.9813 6.64775H16.629C17.0708 6.64775 17.429 7.00593 17.429 7.44775C17.429 7.88958 17.0708 8.24775 16.629 8.24775H14.9813C13.942 8.24775 13.1 9.09062 13.1 10.129V20.7358C13.1 21.1777 12.7418 21.5358 12.3 21.5358C11.8582 21.5358 11.5 21.1777 11.5 20.7358V10.129Z",
    fill: "currentColor",
    fillRule: "evenodd"
  }), React.createElement("path", {
    clipRule: "evenodd",
    d: "M8.7 12.1826C8.7 11.7408 9.05817 11.3826 9.5 11.3826H16.2641C16.7059 11.3826 17.0641 11.7408 17.0641 12.1826C17.0641 12.6244 16.7059 12.9826 16.2641 12.9826H9.5C9.05817 12.9826 8.7 12.6244 8.7 12.1826Z",
    fill: "currentColor",
    fillRule: "evenodd"
  }), React.createElement("path", {
    clipRule: "evenodd",
    d: "M13.0664 20.6358C17.9817 20.6358 21.9664 16.6512 21.9664 11.7358C21.9664 6.82051 17.9817 2.83584 13.0664 2.83584C8.15107 2.83584 4.16641 6.82051 4.16641 11.7358C4.16641 16.6512 8.15107 20.6358 13.0664 20.6358ZM13.0664 22.2358C18.8654 22.2358 23.5664 17.5348 23.5664 11.7358C23.5664 5.93685 18.8654 1.23584 13.0664 1.23584C7.26742 1.23584 2.56641 5.93685 2.56641 11.7358C2.56641 17.5348 7.26742 22.2358 13.0664 22.2358Z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}
IconFacebook.displayName = "IconFacebook";
var make = IconFacebook;
export { make };
/* react Not a pure module */